import React from 'react';
import { Lock } from 'lucide-react';

const Popia = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <Lock className="w-16 h-16 mx-auto text-slate-700 mb-4" />
            <h1 className="text-4xl font-bold text-slate-900 mb-4">POPIA Statement</h1>
            <p className="text-slate-600">Protection of Personal Information Act Compliance</p>
            <p className="text-slate-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm p-8 lg:p-12 space-y-8">
            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-600">
                Au Pair Share is committed to full compliance with the Protection of Personal Information Act, 2013 (POPIA).
              </p>
              
              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Our POPIA Commitment</h2>
              <p className="text-slate-700 leading-relaxed">
                We process all personal information in accordance with POPIA's eight conditions for lawful processing:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mt-4">
                <li>Accountability</li>
                <li>Processing limitation</li>
                <li>Purpose specification</li>
                <li>Further processing limitation</li>
                <li>Information quality</li>
                <li>Openness</li>
                <li>Security safeguards</li>
                <li>Data subject participation</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Information Officer</h2>
              <p className="text-slate-700 leading-relaxed">
                Au Pair Share has appointed an Information Officer responsible for ensuring POPIA compliance. Contact details are available in the app.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Lawful Processing</h2>
              <p className="text-slate-700 leading-relaxed">
                We only process personal information with your consent or where necessary to:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mt-4">
                <li>Provide childcare services you have requested</li>
                <li>Fulfill contractual obligations</li>
                <li>Comply with legal obligations</li>
                <li>Protect the safety of children and users</li>
                <li>Pursue legitimate interests</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Special Personal Information</h2>
              <p className="text-slate-700 leading-relaxed">
                Given the nature of childcare services, we may process special categories of personal information (e.g., children's data, background checks) with appropriate safeguards and only where necessary for service delivery.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Your Rights Under POPIA</h2>
              <p className="text-slate-700 leading-relaxed">
                You have the right to:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mt-4">
                <li>Request access to your personal information</li>
                <li>Request correction of inaccurate information</li>
                <li>Object to processing of your information</li>
                <li>Request deletion of your information (subject to legal requirements)</li>
                <li>Lodge a complaint with the Information Regulator</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Data Retention</h2>
              <p className="text-slate-700 leading-relaxed">
                We retain personal information only as long as necessary for the purposes for which it was collected or as required by law. Background checks and safety records may be retained for longer periods to ensure ongoing child protection.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Cross-Border Data Transfers</h2>
              <p className="text-slate-700 leading-relaxed">
                Your personal information is primarily stored and processed within South Africa. Any international transfers comply with POPIA requirements for adequate protection.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Contact Us</h2>
              <p className="text-slate-700 leading-relaxed">
                For questions about POPIA compliance, to exercise your rights, or to contact our Information Officer, please use the contact options in the Au Pair Share app.
              </p>

              <div className="bg-slate-50 rounded-lg p-6 mt-8">
                <p className="text-slate-700 font-medium">
                  For detailed POPIA compliance documentation and to exercise your data rights, please visit the Au Pair Share app.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popia;
